export default __webpack_public_path__ + "static/media/cloud-upload.41bb889a.svg";